import type { IntlShape } from 'react-intl'
import type { KeywordHeader } from './types'

export const keywordHeaders: KeywordHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Table column header: Code',
			}),
		key: 'code', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kuvaus',
				description: 'Table column header: Description',
			}),
		key: 'description', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
]
